/**
 * Module for loading JS dependencies.
 * @module  utils/request
 */

/**
 * Loads an external Javascript file and executes it.
 * @param {String} url - URL to a JS resource.
 * @param {Function} [check=true] - An optional function that should return true/false (strict) for checking if the loaded JS file has executed correctly.
 * @param {Number} [timeout=10000] - The fail timeout.
 * @return {Promise} 
 */
let loadedDependencies = null;
export function dependency(url, check = _ => true, timeout = 10000) {

  // Lock off any existing dependencies so we don't load them twice
  if (!loadedDependencies) {
    loadedDependencies = {};
    document.querySelectorAll('script[src]').forEach(script => {
      loadedDependencies[script.getAttribute('src')] = true;
    });
  }

  // Return load promise
  return new Promise((resolve, reject) => {
    let startTime = Date.now();
    const poll = _ => {

      if (check() === true) resolve();
      else if (Date.now() - startTime > timeout) reject();
      else setTimeout(poll, 50);
    }
    if (!loadedDependencies[url]) {

      loadedDependencies[url] = true;
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onload = poll;
      document.head.appendChild(script);
    } else {
      poll();
    }
  });
}



// WEBPACK FOOTER //
// ./source/scripts/utils/request.js